module.exports = __webpack_public_path__ + "static/media/papeldeparede2.ecd03b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/papeldeparede2.png
// module id = 52
// module chunks = 0